import React from 'react';
import styled from 'styled-components';
export default ({ isPremium }) => {
    if (isPremium) {
        return (React.createElement(IconOpen, { src: "/icons/lock-open-black.png", alt: "lock open icon" }));
    }
    return (React.createElement(IconLocked, { src: "/icons/lock-black.png", alt: "lock closed icon" }));
};
const DefaultLock = styled.img `
  width: 12px;
  margin-left: 6px;
`;
const IconLocked = styled(DefaultLock) `
  opacity: 0.5;
`;
const IconOpen = styled(DefaultLock) `
  opacity: 0.2;
`;
